import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppFormComponent, SelectOption } from '@shared/components/ui/list-components';
import { DeleteTrigger } from '@shared/components/ui/delete-trigger/delete-trigger';
import { InputFieldComponent } from '@shared/components/form/input/input-field.component';
import { LabelComponent } from '@shared/components/form/label/label.component';
import { SelectFieldComponent } from '@shared/components/form/select/select-field.component';
// Sin observación en el panel: el textarea quedó comentado en el template.
// import { TextareaFieldComponent } from '@shared/components/form/textarea/textarea-field.component';
import { ProduccionEtapa } from './produccion-etapa.model';

/** Formulario de la producción de una etapa, dentro del desplegable de su fila. */
@Component({
  selector: 'app-produccion-etapa',
  imports: [AppFormComponent, DeleteTrigger, InputFieldComponent, LabelComponent, ReactiveFormsModule,
    SelectFieldComponent /* , TextareaFieldComponent */],
  templateUrl: './produccion-etapa.html',
})
export class ProduccionEtapaPanel {
  @Input({ required: true }) modelo!: ProduccionEtapa;
  @Input() canDelete = false;
  @Input() deshabilitado = false;
  /** AM7/PM7: formulario del control del día, para cargar estadio y grado en el mismo bloque. */
  @Input() controlForm?: FormGroup;
  @Input() estadiosOptions: SelectOption[] = [];
  @Input() tecnicasCongelamientoOptions: SelectOption[] = [];
  @Input() opsPuntosOptions: SelectOption[] = [];
  @Input() opsColoresOptions: SelectOption[] = [];
  @Output() eliminar = new EventEmitter<void>();

}
